export class AuthenticationModel {
    public username: string;
    public password: string;
    public isActiveDomainAccount: boolean;
    public domainName: string;
}
